<template>
  <global-modal name="order-success" @before-open="beforeOpen">
    <Modal popup @close="$modal.hide('order-success')" :callback="callback">
      <section class="order-modal popup-modal">
        <div class="popup-modal__header">
          <span class="popup-modal__title">
            {{ $t("services.ordering.success") }}
          </span>
        </div>
        <div class="popup-modal__body">
          <span
            v-for="(order, i) in data"
            :key="i"
            class="order-modal__text popup-modal__text"
          >
            {{
              $t("services.ordering.orderNumber", {
                id: order.id,
                date: order.created_at
              })
            }}
          </span>
        </div>
      </section>
    </Modal>
  </global-modal>
</template>

<script>
import Modal from "@/components/Modal/Modal.vue";

export default {
  name: "OrderSuccessModal",
  components: {
    Modal
  },
  data() {
    return {
      data: []
    };
  },
  methods: {
    beforeOpen(event) {
      if (event.params && event.params.data) {
        this.data = event.params.data;
      }
    },
    callback() {
      this.$router.push({ name: "orders" });
    }
  }
};
</script>

<style lang="scss" scoped>
.order-modal {
  &__text {
    display: block;

    &:not(:last-of-type) {
      margin-bottom: 10px;
    }
  }
}
</style>
